const FUNCTION_URL = `https://nbhzbstabtkjrhrwfhoj.supabase.co/functions/v1/simulator-webhook`;
const ANON_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im5iaHpic3RhYnRranJocndmaG9qIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjM3NjcwMjUsImV4cCI6MjA3OTM0MzAyNX0.iJ4w5kRK-jv0n40HxGStEIgVkj0U5pzqzfEpR0ZPOq4";

async function fipeRequest(params: Record<string, string>) {
  const query = new URLSearchParams(params).toString();
  const res = await fetch(`${FUNCTION_URL}?${query}`, {
    method: "GET",
    headers: { apikey: ANON_KEY },
  });
  if (!res.ok) {
    // Fallback: try direct FIPE API (may work without CORS in some browsers)
    const FIPE_BASE = "https://parallelum.com.br/fipe/api/v1/carros";
    let fipeUrl = `${FIPE_BASE}/marcas`;
    if (params.action === "modelos" && params.marca) fipeUrl = `${FIPE_BASE}/marcas/${params.marca}/modelos`;
    else if (params.action === "anos" && params.marca && params.modelo) fipeUrl = `${FIPE_BASE}/marcas/${params.marca}/modelos/${params.modelo}/anos`;
    else if (params.action === "valor" && params.marca && params.modelo && params.ano) fipeUrl = `${FIPE_BASE}/marcas/${params.marca}/modelos/${params.modelo}/anos/${params.ano}`;
    
    const fallback = await fetch(fipeUrl);
    if (!fallback.ok) throw new Error("Erro ao consultar FIPE");
    return fallback.json();
  }
  return res.json();
}

export interface FipeMarca {
  codigo: string;
  nome: string;
}

export interface FipeModelo {
  codigo: number;
  nome: string;
}

export interface FipeAno {
  codigo: string;
  nome: string;
}

export interface FipeValor {
  Valor: string;
  Marca: string;
  Modelo: string;
  AnoModelo: number;
  Combustivel: string;
  CodigoFipe: string;
  MesReferencia: string;
}

export async function fetchMarcas(): Promise<FipeMarca[]> {
  return fipeRequest({ action: "marcas" });
}

export async function fetchModelos(marcaId: string): Promise<{ modelos: FipeModelo[] }> {
  return fipeRequest({ action: "modelos", marca: marcaId });
}

export async function fetchAnos(marcaId: string, modeloId: string): Promise<FipeAno[]> {
  return fipeRequest({ action: "anos", marca: marcaId, modelo: modeloId });
}

export async function fetchValor(marcaId: string, modeloId: string, anoCode: string): Promise<FipeValor> {
  return fipeRequest({ action: "valor", marca: marcaId, modelo: modeloId, ano: anoCode });
}

export function parseFipeValue(valorStr: string): number {
  return Number(valorStr.replace(/[R$\s.]/g, "").replace(",", "."));
}
